module.exports = __webpack_public_path__ + "img/orange.54c29981.png";